import axios from "axios";

export default {
    async getVapidPublicKey() {
        const data = new FormData();
        data.append("limit", "1");

        const response = await axios.post(`rest/v1/search/app_mobile_settings`, data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });

        return response;
    },
};


